export let CompanySizeScreamingSnake;
(function (CompanySizeScreamingSnake) {
  CompanySizeScreamingSnake["ONE"] = "ONE";
  CompanySizeScreamingSnake["TwoToFive"] = "TWO_TO_FIVE";
  CompanySizeScreamingSnake["SixToTen"] = "SIX_TO_TEN";
  CompanySizeScreamingSnake["ElevenToTwentyFive"] = "ELEVEN_TO_TWENTY_FIVE";
  CompanySizeScreamingSnake["TwentySixToHundred"] = "TWENTY_SIX_TO_FIFTY";
  CompanySizeScreamingSnake["FiftyOneToTwoHundred"] = "FIFTY_ONE_TO_TWO_HUNDRED";
  CompanySizeScreamingSnake["TwoHundredAndOneToOneThousand"] = "TWO_HUNDRED_AND_ONE_TO_ONE_THOUSAND";
  CompanySizeScreamingSnake["OneThousandAndOnetoTenThousand"] = "ONE_THOUSAND_AND_ONE_TO_TEN_THOUSAND";
  CompanySizeScreamingSnake["TenThousandAndOneOrMore"] = "TEN_THOUSAND_AND_ONE_OR_MORE";
})(CompanySizeScreamingSnake || (CompanySizeScreamingSnake = {}));